import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Col, Row, Typography, Image } from "antd";
import "./section_title.css";

//redux
import { useDispatch, useSelector } from "react-redux";
import { snapDetail, unSnapDetail } from "../store/branch/branch.action";
import { detailSelector } from "../store/branch/branch.selector";

const { Title, Paragraph } = Typography;

const SectionTitle = (props) => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const id = params?.id || "";
  const title = props?.title || "";
  const subtitle = props?.subtitle || "";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const detail = useSelector(detailSelector);
  const logo = detail?.logo || null;
  const name = detail?.name || "";
  const phone = detail?.phone || "";
  const address = detail?.address || "";
  const email = detail?.email || "";
  const shopId = detail?.shopId || "";
  console.log("detail", detail);
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (id !== "") {
      dispatch(snapDetail({ id }));
    }

    return () => dispatch(unSnapDetail({ id }));
  }, [id]);
  // -------------------------- RENDER --------------------------

  const renderLogo = () => {
    return (
      <Col align="center">
        <Image className="logo-image" src={logo} />
        <div style={{ marginTop: 10 }}>
          <b className="branch-detail-title">{name}</b>
        </div>
      </Col>
    );
  };

  const renderMeta = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <h1 className="branch-title-detail ">Shop Details</h1>
          <div className="bottom-line"></div>
        </Col>
        <Col span={24}>
          <b>• Email</b>: {email}
        </Col>
        <Col span={24}>
          <b>• Telephone</b>: {phone}
        </Col>
        <Col span={24}>
          <b>• Shop Name</b>: {name}
        </Col>
        <Col span={24}>
          <b>• Shop ID</b> : {shopId}
        </Col>
        <Col span={24}>
          <b>• Shop Address</b>: {address}
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row
      gutter={[16, 0]}
      className="section-container"
      justify="center"
      align="middle"
    >
      <Col xs={24} sm={24} md={24} lg={7} xl={7} xxl={7}>
        {renderLogo()}
      </Col>
      <Col
        style={{ margin: "20px 0px" }}
        xs={24}
        sm={24}
        md={24}
        lg={17}
        xl={17}
        xxl={17}
      >
        {renderMeta()}
      </Col>
    </Row>
  );
};

export default SectionTitle;
